module.exports = __webpack_public_path__ + "static/media/logosii.7b180d9f.png";